module.exports = __webpack_public_path__ + "media/assets/expand-toggle-icon-9793c88369c80588b3032a11395ca037a9b474986a81be48b111f34a14cc738a.png";